function PlusIcon({ color, opacity = 0.2 }) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.445" y="0.445" width="30.7347" height="30.7347" rx="15.3674" fill="white" />
            <path
                d="M10.6631 15.8125H20.9619M15.8125 10.6631V20.9619"
                stroke="#5E718D"
                strokeWidth="1.24834"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="0.445"
                y="0.445"
                width="30.7347"
                height="30.7347"
                rx="15.3674"
                stroke="#D7DFE9"
                strokeWidth="0.89"
            />
        </svg>
    );
}

export default PlusIcon;
